import {
    $get,
    $post
  } from '@/utils/http'
  // 审查调查
export default {
    // 审查调查
    getDj(params) {
      return $post('/portal/review/punishmentReview/listReview', params)
    },
  //  党纪详情
  getDj1(params) {
    return $post('/portal/review/punishmentReview/getReviewById', params)
  },
  }